var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isloaded)?_c('div',{staticClass:"ReportPage"},[_c('Report',{attrs:{"token":_vm.token,"userType":_vm.ConnecteduserType}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }